import { render, staticRenderFns } from "./COMScreen5.vue?vue&type=template&id=b192e910"
import script from "./COMScreen5.vue?vue&type=script&lang=js"
export * from "./COMScreen5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports